import React from 'react';
import useUpdatePreview from '@lib/prismic/util/useUpdatePreviewRef';
import InteriorDesignServices
  from '@components/pages/MarketingPages/InteriorDesignServices/InteriorDesignServices';
import { GetStaticProps } from 'next';
import getPrismicStaticProps from '@lib/prismic/getPrismicStaticProps';

export default function InteriorDesignServicesPage(props: any) {
  const {
    previewRef,
    prismicDoc,
    data
  } = props;
  useUpdatePreview(previewRef, prismicDoc.id);

  return (
    <InteriorDesignServices
      prismicData={data}
    />
  );
}

export const getStaticProps: GetStaticProps = getPrismicStaticProps({
  docType: 'how_it_works_page',
  docUID: 'interior-design-services'
});

